import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
  Renderer2,
  HostListener,
  PLATFORM_ID,
  Inject,
  TemplateRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { IPayPalConfig, ICreateOrderRequest } from "ngx-paypal";
import { environment } from "../../../environments/environment";
import { Product } from "../../shared/classes/product";
import { ProductService } from "../../shared/services/product.service";
import { OrderService } from "../../shared/services/order.service";
import { CommonService } from "../../shared/services/common.service";
import { UserService } from "../../shared/services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { MatExpansionPanel } from "@angular/material/expansion";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { isPlatformBrowser } from "@angular/common";
import { MatRadioButton } from "@angular/material/radio";
import { TranslateService } from "@ngx-translate/core";
import { HttpErrorResponse } from "@angular/common/http";
import { FatoorahPaymentService } from "src/app/shared/services/fatoorah-payment.service";
import { json } from "express";
import { MasterApiService } from "src/app/shared/services/master-api.service";
import { KnetPaymentService } from "src/app/shared/services/knet-payment.service";

@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
})
export class CheckoutComponent implements OnInit, OnDestroy {
  @ViewChildren("home") home: QueryList<ElementRef<any>>;
  @ViewChildren("store") store: QueryList<ElementRef<any>>;
  @ViewChild("mySelect") mySelect: ElementRef;
  @ViewChild("modal") modal: ElementRef;
  @ViewChild("btnInvoice") btnInvoice: ElementRef;
  @ViewChild("disableLayer") disableLayer: ElementRef;
  @ViewChild("layer") layer: ElementRef;
  @ViewChildren("panel") panels: QueryList<ElementRef<any>>;
  @ViewChildren("radioContainer") radioContainer: QueryList<ElementRef<any>>;
  @ViewChildren("PaymentContainer") paymentContainer: QueryList<
    ElementRef<any>
  >;
  @ViewChildren("btnCompany") btnCompanies!: QueryList<MatRadioButton>;
  @ViewChildren("btnpayment") btnPayments: QueryList<MatRadioButton>;

  public checkoutForm: FormGroup;
  public products: Product[] = [];
  public cart_products: any;
  public cart_products_total_price = "";
  public cart_products_total_price_final: any;
  public countItems = "0";
  public totalDiscounts = "0";
  public product_items: any[] = [];
  public defaulty: string = "1225";

  public payPalConfig?: IPayPalConfig;
  public payment: string = "Stripe";
  public amount: any;
  public countries: any[] = [];
  public country_id = "";
  public country_name: any;
  public cities: any[] = [];
  public Districts: any[] = [];
  public myAddresess: any[] = [];
  public noMyAddresess: boolean = false;
  public myAddresessError: boolean = false;
  public addresessError: boolean = false;
  public quantatyMorThanStor: boolean = false;
  // public selectedAddresse: any[] = [];
  public city_id = "";
  public address = "";
  public savedaddress = "";
  public defaultAddress: any;
  // public note = "";
  public delivery_price = "";
  public addressIdFromCart = "";
  page_name = localStorage.getItem("front-lang") == "ar" ? "الدفع" : "Checkout";
  userLogedIn: boolean = false;
  deviceID: boolean = false;
  currentUser: any;
  user_img = "";
  existImg: boolean = false;
  user_full_name = "";
  usre_id: any;
  modalRef?: NgbModalRef;
  addInvoiceErrorResponce: string = "";
  public couponDiscount: any;
  cartId: any;
  marketingData: any;
  totalCartDiscount: any;
  loading = true;
  importApiImage: string;
  urlimage: string;
  contactInfoData: any;
  userInfo: any;
  homepanelOpenState: boolean = true;
  storepanelOpenState: boolean = false;
  allDoneMessage: any[] = [];
  inVoiceId: string = "";
  currentRoute: any;
  myColor: string = "";
  subscription: Subscription;
  constructorDone: boolean = false;
  FirstAddressId: number;
  checkLoading: boolean = false;
  checkCompleted: boolean = false;
  user_name: string = "";
  last_name: string = "";
  mobile_data: string = "";
  mobile2_data: string = "";
  successUser_name: boolean = false;
  successLast_name: boolean = false;
  public errorUserNameMessage = "";
  public errorLastNameMessage = "";
  successMobile: boolean = false;
  successMobile2: boolean = false;
  errorMobileMessage = "";
  errorMobileMessage2 = "";
  successPassword: boolean = false;
  successconfirmPassword: boolean = false;
  errorPasswordMessage = "";
  errorconfirmPasswordMessage = "";
  phoneplaceholder: string = "";
  phone2placeholder: string = "";
  mobileLength: number = 0;
  keyLength: number = 0;
  valid_mobile: string = "";
  valid2_mobile: string = "";
  mobile_keys = [];
  mobilePattern = /^[0-9]+$/;
  mobileIsValid: boolean = false;
  mobile2IsValid: boolean = false;
  mobileIsInValid: boolean = false;
  mobile2IsInValid: boolean = false;
  country_code: any;
  image_mobile: string;
  _image_code: string = this.Common._imageUrlPlaces;
  paymentLoading: boolean = true;
  @Input() errorOccurred = false;
  errorOccurredMessage: string;
  // ?modal variables====
  @ViewChild("newsletter", { static: false }) NewsLetterModal: TemplateRef<any>;
  @ViewChild("paymentlet", { static: false }) paymentModal: TemplateRef<any>;

  public openDashboard: boolean = false;

  step1: boolean = false;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;
  step11: boolean = false;
  step22: boolean = false;
  step33: boolean = false;

  addStep: boolean = false;
  editStep: boolean = false;
  public countriesModal: any[] = [];
  public country_idModal = "";
  public country_nameModal: any;
  public myAddresessModal: any[] = [];
  public citiesModal: any[] = [];
  public city_idModal = "";
  public district_id = "";
  public title = "";
  public delete_address_id = "";
  public city_nameModal: any;
  public address_id = "";
  public city_name: string = "";
  public district_name: string = "";

  public closeResult: string;
  public modalOpen: boolean = false;
  is_default: string = "1";
  haveDefault: boolean = false;
  count_invoice: any;
  checkBtnLoader: boolean = false;
  // shippingMethodBlock: boolean[] = [];
  total_payment_price: number = 0;
  user_info: any = {};
  index: number = 0;
  paymentInfo: any[] = [];
  baseUrl: string = "";
  paymentDetails = { amount: 0, trackId: '' };
  addWallet:boolean = false; 
  isClient: boolean = true;
  promoDiscount: any;
  promoType: any;
  noTotalAmmount: any;
  constructor(
    private fb: FormBuilder,
    public user: UserService,
    public Common: CommonService,
    private router: Router,
    public productService: ProductService,
    private orderService: OrderService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private host: ElementRef,
    private FatoorahPaymentService: FatoorahPaymentService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private MasterApiService: MasterApiService,
    private paymentService: KnetPaymentService
  ) {
    // SET TITLE
    this.Common.setTitle(this.page_name);

    let clientType =JSON.parse(localStorage.getItem('currentUserFront')!)?.user_type
    // clientType ='contributor'
    this.isClient = clientType == 'contributor' ? false : true

    this.importApiImage = this.Common._ImageUrl + "importapi/";
    this.urlimage = this.Common._ImageUrl + "products/";
    this._image_code = this.Common._imageUrlPlaces + "places/";
    this.subscription = this.Common.UpdatedChecckOut.subscribe({
      next: (res) => {
        this.getCartItemsFromServer();
      },
    });
    // console.log(this.user);
    this.checkoutForm = this.fb.group({
      title: ["", [Validators.required, Validators.maxLength(255)]],
      country: ["", Validators.required],
      city: ["", Validators.required],
      District: ["", Validators.required],
      is_default: ["1", Validators.required],
      company: ["0", Validators.required],
    });
  }
  @ViewChild("styledButton") styledButton: ElementRef;

  ngOnInit(): void {
    this.baseUrl = window.location.origin;
    console.log("Base URL:", this.baseUrl);
    this.productService.cartItems.subscribe(
      (response) => (this.products = response)
    );
    this.contactInfoData =
      JSON.parse(localStorage.getItem("contactinfo")) || {};
    console.log("contactInfoData", this.contactInfoData);
    this.initConfig();
    this.getPlaces(0);
    //this.getAllAddress();
    this.checkOuth();
    //this.getCartItemsFromServer();
    // this.getAllContanctInfo();
    const rootStyles = getComputedStyle(document.documentElement);
    const themeDefault = rootStyles.getPropertyValue("--theme-default").trim();
    if (this.styledButton) {
      this.styledButton.nativeElement.style.color = themeDefault;
    }
  }

  getPromoDiscountValue()
  {
    let promo = JSON.parse(localStorage.getItem("promo")!)
    // promo = {
    //   "PROMO_ID": 5,
    //   "PROMO_AMOUNT": 0,
    //   "PROMO_TYPE_ID": 3,
    //   "PROMO_VALUE_DEF": 20,
    //   "PROMO_SH_ID": 3,
    //   "PROMO_BOX_NO": 3,
    //   "SH_NAME": "عبدالمحسن عبدالله",
    //   "PROMO_TRANS_SUM": 0,
    //   "PROMO_TRANS_COUNT": 0,
    //   "USER_MSG": "\n\rمسابقة رمضان 2023 كوبون دفع على بطاقة العائلة بقيمة 20.000\n\rمشتريات سابقة :0.000 دينار\n\rالرصبد المتاح: 20.000 دينار\n\r من تاريخ:2023/01/01\n\r إلى تاريخ:2025/12/31\n\r الاسم:عبدالمحسن عبدالله",
    //   "IS_AFFECT_SH_PUR": 0
    // }
    if (promo) {
      let total = (this.cart_products['total_price'] - this.cart_products['total_coupon_discount'] -
        this.cart_products['total_discount'] + this.cart_products.deliveryPrice-this.cart_products['total_quantity_discount'] +this.cart_products.paymentServicePrice)
      this.promoDiscount =  total > promo?.PROMO_VALUE_DEF ? promo?.PROMO_VALUE_DEF  :total 
      this.noTotalAmmount =  total > promo?.PROMO_VALUE_DEF ? true  : false 
      this.promoType = promo?.PROMO_TYPE_ID
    }
    console.log(this.noTotalAmmount);
    
  }
  ngAfterViewInit(): void {
    this.homepanelOpenState = true;
    this.storepanelOpenState = false;

    // setTimeout(() => {
    //   this.setInitialCheck();
    //   this.cdr.detectChanges();
    // }, 1600);
  }

  setInitialCheck() {
    const shippingContainersArray = this.radioContainer.toArray();
    const btnCompaniesArray = this.btnCompanies.toArray();
    const paymentContainersArray = this.paymentContainer.toArray();
    const btnPaymentsArray = this.btnPayments.toArray();
    console.log("cart_products", this.cart_products);
    
      const startShippingIndex =
        0 * this.cart_products.selectedAddresse?.shipping_methods?.length;
      const endShippingIndex =
        startShippingIndex +
        this.cart_products.selectedAddresse?.shipping_methods?.length;
      const startPaymentIndex = 0 * this.paymentInfo.length;
      const endPaymentIndex = startPaymentIndex + this.paymentInfo.length;

      const cartItemCompanyContainers = shippingContainersArray.slice(
        startShippingIndex,
        endShippingIndex
      );

      const cartItemBtnCompanies = btnCompaniesArray.slice(
        startShippingIndex,
        endShippingIndex
      );

      const cartItemPaymentContainers = paymentContainersArray.slice(
        startPaymentIndex,
        endPaymentIndex
      );

      const cartItemBtnPayments = btnPaymentsArray.slice(
        startPaymentIndex,
        endPaymentIndex
      );

      

      if (
        cartItemCompanyContainers.length > 0 &&
        cartItemBtnCompanies.length > 0
      ) {
        cartItemCompanyContainers[
          this.cart_products.shippingIndex
        ].nativeElement.style.border = `2px solid ${this.myColor}`;

        cartItemBtnCompanies[this.cart_products.shippingIndex].checked = true;
      }

      if (
        cartItemPaymentContainers.length > 0 &&
        cartItemBtnPayments.length > 0
      ) {
        cartItemPaymentContainers[
          this.cart_products.paymentIndex
        ].nativeElement.style.border = `2px solid ${this.myColor}`;
        cartItemBtnPayments[this.cart_products.paymentIndex].checked = true;
      }
    
  }

  onCloseModal(modal: HTMLElement, layer: HTMLElement) {
    modal.style.bottom = "-150%";
    layer.style.display = "none";
  }
  openModalAddresses(modal: HTMLElement, layer: HTMLElement) {
    modal.style.bottom = "-10px";
    modal.style.overflow = "auto";
    layer.style.display = "block";
  }

  checkLength() {
    this.valid_mobile = this.formatMobileNumber(this.mobile_data);

    this.mobileIsValid = false;
    if (
      !this.startsWithAny(this.mobile_keys, this.valid_mobile) &&
      this.valid_mobile.length >= this.keyLength
    ) {
      this.errorOccurred = true;
      this.successMobile = true;
      this.mobileIsInValid = true;

      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
          this.errorMobileMessage = translatedMessage;
        });
    } else {
      this.errorOccurred = false;
      this.successMobile = false;
      this.mobileIsInValid = false;
      if (this.valid_mobile.length == this.mobileLength) {
        this.mobileIsValid = true;
      } else if (this.valid_mobile.length > this.mobileLength) {
        this.mobileIsInValid = true;
        this.mobileIsValid = false;
      } else {
        this.mobileIsValid = false;
      }
      this.errorOccurredMessage = "";
      this.errorMobileMessage = "";
    }
  }

  checkLength2() {
    this.valid2_mobile = this.formatMobileNumber(this.mobile2_data);
    this.mobile2IsValid = false;
    console.log(
      !this.startsWithAny(this.mobile_keys, this.valid2_mobile),
      this.mobile_keys,
      this.valid2_mobile
    );
    if (
      !this.startsWithAny(this.mobile_keys, this.valid2_mobile) &&
      this.valid2_mobile.length >= this.keyLength
    ) {
      this.errorOccurred = true;
      this.successMobile2 = true;
      this.mobile2IsInValid = true;

      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
          this.errorMobileMessage2 = translatedMessage;
        });
    } else {
      this.errorOccurred = false;
      this.successMobile2 = false;
      this.mobile2IsInValid = false;
      if (this.valid2_mobile.length == this.mobileLength) {
        this.mobile2IsValid = true;
      } else if (this.valid2_mobile.length > this.mobileLength) {
        this.mobile2IsInValid = true;
        this.mobile2IsValid = false;
      } else {
        this.mobile2IsValid = false;
      }
      this.errorOccurredMessage = "";
      this.errorMobileMessage2 = "";
    }
  }

  startsWithAny(array, number) {
    const numStr = number.toString();
    return array.some((element) => numStr.startsWith(element.toString()));
  }
  formatMobileNumber(mobileNumber) {
    // if (mobileNumber.charAt(0) !== "0" && mobileNumber.length > 0) {
    //   mobileNumber = "0" + mobileNumber;
    // }
    return mobileNumber;
  }

  getAllContanctInfo() {
    this.MasterApiService.getCurrentDataContact().subscribe(
      (dataContact) => {
        if (!dataContact) {
          console.error("Data contact information is undefined or null");
          return;
        }

        this.contactInfoData = dataContact;
        localStorage.setItem("contactinfo", JSON.stringify(dataContact));
        this.myColor = this.contactInfoData.front_color;
        this.country_idModal = dataContact["country_info"].id;
        this.onChangeCountry(this.country_idModal);
        this.country_code = dataContact["country_info"].country_code;
        this.image_mobile = this.Common._ImageUrl + 'places/' + dataContact["country_info"].image;
        this.mobile_keys = dataContact["country_info"].mobile_keys.split(",");
        this.mobileLength = parseFloat(dataContact["country_info"].mobile_length);
        this.keyLength = this.mobile_keys[0].length;
        const len = this.mobileLength - this.keyLength;
        this.phoneplaceholder = this.mobile_keys[0];
        for (let index = 0; index < len; index++) {
          this.phoneplaceholder += "x";
        }
        this.phone2placeholder = this.mobile_keys[0];
        for (let index = 0; index < len; index++) {
          this.phone2placeholder += "x";
        }
        localStorage.setItem(
          "paymentInfo",
          JSON.stringify(this.Common.getAllPaymentMethods(this.contactInfoData))
        );
        this.paymentInfo = this.Common.getAllPaymentMethods(
          this.contactInfoData
        )
          ? this.Common.getAllPaymentMethods(this.contactInfoData)
          : JSON.parse(localStorage.getItem("paymentInfo"));

        // this.cart_products.forEach((ele, index) => {
        console.log("paymentInfo", this.paymentInfo);
        this.paymentInfo.forEach((info, index) => {
          if (info.key == this.cart_products.payment_method_type) {
            this.cart_products.paymentIndex = index;
            this.cart_products.paymentKey = info.key;
            this.cart_products.paymentName = info.name;
            this.cart_products.paymentPrice = info.price;
          }
        });
        // });

        this.userInfo = JSON.parse(this.user.getCurrentUser());
      },
      (error) => {
        console.error("Error fetching contact info", error);
      }
    );
  }
  focusSelect(): void {
    this.renderer.selectRootElement(this.mySelect.nativeElement).focus();
  }
  removeBrackets(str: string): string {
    return str.replace(/[(\%)/]/g, "");
  }

  getCartItemsFromServer() {
    this.loading = true;
    this.Common.getCart().subscribe(async (data) => {
      this.products = [];
      if (data.data) {
        this.cart_products = data.data;
        this.calculateTotalPaymentPrice();
        console.log("cart", this.cart_products);
        if (this.cart_products["product_items"].length > 0) {
          this.products.push(this.cart_products["product_items"]);
          this.cart_products["panelOpenState"] = false;
        }
        this.cart_products["shippingnNum"] = "my_address";

        // this.cart_products.forEach((ele) => {
        this.checkLoading = false;
        this.checkCompleted = false;
        this.myAddresessError = false;
        if (this.cart_products["address_id"] != null) {
          this.FirstAddressId = this.cart_products["address_id"];
        }
        this.cart_products["paymentKey"] = "payment_method_home";
        this.cart_products["paymentName"] =
          this.contactInfoData["payment_method_home_name"];
        this.cart_products["paymentPrice"] =
          this.contactInfoData["payment_method_home_price"];
        this.cart_products["paymentServicePrice"] = this.cart_products[
          "payment_method_price"
        ]
          ? this.cart_products["payment_method_price"]
          : parseFloat(this.cart_products["paymentPrice"]);
        this.cart_products["note"] = this.cart_products["note"]
          ? this.cart_products["note"]
          : "";
        this.cart_products["deliveryPrice"] = 0;
        this.cart_products["shippingValue"] = 0;
        this.cart_products["shippingId"] = 0;
        this.cart_products["shippingCompany"] = "";
        // this.cart_products['sthis']['cart_productsctedAddresse'] = [];
        this.cart_products["shippingIndex"] =
          this.cart_products["shippingIndex"] > 0
            ? this.cart_products["shippingIndex"]
            : 0;
        this.cart_products["paymentIndex"] =
          this.cart_products["paymentIndex"] > 0
            ? this.cart_products["paymentIndex"]
            : 0;
        this.cart_products["shippingMethodBlock"] = true;
        // });
        // console.log(this.checkCompleted);
        // console.log(this.FirstAddressId);
        this.cart_products["panelOpenState"] = true;
        this.cart_products["homeOpenState"] = true;
        await this.getAllContanctInfo();
        await this.getAllAddress();
        // let shippingMethodBlock: boolean[] = new Array(
        //   this.cart_products.length
        // ).fill(true);

        // this.shippingMethodBlock = shippingMethodBlock;
      } else {
        this.loading = false;
      }

    });
  }

  async calculateTotalPaymentPrice() {
    console.log(this.cart_products);
    this.total_payment_price = 0;
    // for (let index = 0; index < this.cart_products.length; index++) {
    this.total_payment_price +=
      parseFloat(this.cart_products["total_price"]) -
      parseFloat(this.cart_products["total_coupon_discount"]) -
      parseFloat(this.cart_products["total_discount"]) +
      parseFloat(this.cart_products.deliveryPrice) -
      parseFloat(this.cart_products[ "total_quantity_discount"]) +
      +this.cart_products.paymentServicePrice;
    // }
  }

  async getPaymentMethodsAfterCalculation() {
    this.paymentLoading = true;
    await this.calculateTotalPaymentPrice();
    this.getPaymentMethods(this.total_payment_price);
  }

  checkOuth() {
    if (this.user.getToken() !== null && this.user.getDeviceId() !== null) {
      this.userLogedIn = true;
      this.deviceID = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_full_name = this.currentUser.user_name;
      this.user_name = this.currentUser.user_name;
      this.last_name = this.currentUser.last_name || "";
      this.mobile_data = this.currentUser.mobile;
      this.valid_mobile = this.formatMobileNumber(this.mobile_data);
    } else {
      this.userLogedIn = false;
      this.deviceID = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
    }
  }

  async getAllAddress() {
    await this.user.getAllAddress().subscribe((data) => {
      console.log(data);

      if (data.success) {
        this.myAddresess = data.data;
        // console.log(this.myAddresess);

        // console.log(this.deliveryPrice);
        for (let i = 0; i < this.myAddresess.length; i++) {
          if (
            this.FirstAddressId == undefined &&
            this.myAddresess[i].is_default == "1"
          ) {
            this.FirstAddressId = this.myAddresess[i].id;
            this.haveDefault = true;
            // this.cart_products.forEach((item, index) => {
            this.cart_products.selectedAddresse = this.myAddresess[i];
            // });

            break;
          } else if (this.FirstAddressId == this.myAddresess[i].id) {
            // this.cart_products.forEach((item, index) => {
            this.cart_products.selectedAddresse = this.myAddresess[i];
            // });
            break;
          } else {
            // this.selectedAddresse = this.cart_products.map((item, index) => {
            //   return { [`${index}`]: "" };
            // });
            // this.cart_products.forEach((item, index) => {
            this.cart_products.selectedAddresse = this.myAddresess[i];
            // });
          }
        }

        // this.cart_products.forEach((ele, i) => {
        this.cart_products.deliveryPrice =
          this.cart_products.selectedAddresse !== ""
            ? parseFloat(this.cart_products.selectedAddresse.delivery_price)
            : 0;

        this.cart_products.shippingValue =
          this.cart_products.selectedAddresse !== ""
            ? this.cart_products.selectedAddresse.delivery_price
            : 0;

        this.cart_products.shippingId =
          this.cart_products.selectedAddresse !== ""
            ? this.cart_products.selectedAddresse.shipment_id
            : 0;

        this.cart_products.shippingCompany =
          this.cart_products.selectedAddresse !== ""
            ? this.cart_products.selectedAddresse.shipment_company
            : 0;
        this.cart_products.selectedAddresse
          ? this.cart_products.selectedAddresse.shipping_methods.forEach(
              (element, shippingIndex) => {
                if (
                  parseFloat(element.shipment_id) ==
                  parseFloat(this.cart_products.shipment_id)
                ) {
                  this.cart_products.shippingIndex = shippingIndex;
                  this.cart_products.deliveryPrice = parseFloat(
                    element.delivery_price
                  );
                  this.cart_products.shippingCompany = element.shipment_company;
                  this.cart_products.shippingId = element.shippingId;
                  this.cart_products.shippingValue = element.delivery_price;
                }
              }
            )
          : (this.cart_products.shippingIndex = 0);
        // });
        this.loading = false;

        // doing this for edit to remove the shipping way
        if (this.cart_products.shipping_type == "shipping_from_store") {
          this.storeChecked(0);
        }
        this.route.queryParams.subscribe((params) => {
          const paymentId = params["paymentId"];
          if (paymentId) {
            this.addPaymentInvoice(
              this.btnInvoice,
              this.disableLayer,
              paymentId
            );
          }
        });
      } else {
        this.noMyAddresess = true;
        // this.cart_products.forEach((item, index) => {
        this.cart_products.selectedAddresse = "";
        // });

        this.cart_products.deliveryPrice = 0;
        

        this.loading = false;
      }
      setTimeout(() => {
        this.setInitialCheck();
        this.cdr.detectChanges();
      },500)
      this.getPromoDiscountValue()
    });
  }

  getPlaces(parent_id) {
    this.Common.getPlaces(parent_id, this.city_id).subscribe((countries) => {
      if (countries.data) {
        this.countries = countries.data;
        this.countriesModal = countries.data;
      } else {
        //console.log"no data in countries");
      }
    });
  }

  onCityChange(value: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.district_id = "";
      console.log(this.checkoutForm.get("is_default"));

      if (value != "") {
        this.Common.getPlaces(this.country_idModal, value).subscribe((data) => {
          if (data.data) {
            this.Districts = data.data;
            console.log("Districts", this.Districts);
            resolve();
          } else {
            reject("No data in countries");
          }
        });

        for (let i = 0; i < this.countries.length; i++) {
          if (this.countries[i].id == value) {
            this.country_name = this.countries[i].pla_name;
          }
        }
      } else {
        resolve(); // Resolve immediately if value is empty
      }
    });
  }

  AddressTitle: any = "";
  onChangeAddress(value, modal: HTMLElement, layer: HTMLElement) {
    console.log(value);
    if (value !== "") {
      this.cart_products.selectedAddresse = this.myAddresess.filter(
        (ele) => ele.id == value
      )[0];
      this.myAddresessError = false;
    } else {
      this.cart_products.selectedAddresse = null;
    }
    this.FirstAddressId = this.myAddresess.filter(
      (ele) => ele.id == value
    )[0].id;
    if (this.cart_products.selectedAddresse == null) {
      this.myAddresessError = true;
    }
    this.cart_products.deliveryPrice = parseFloat(
      this.cart_products.selectedAddresse.delivery_price
    );
    this.cart_products.shippingValue =
      this.cart_products.selectedAddresse.shipment_value;
    this.cart_products.shippingId =
      this.cart_products.selectedAddresse.shipment_id;
    this.cart_products.shippingCompany =
      this.cart_products.selectedAddresse.shipment_company;
    this.cart_products.shippingIndex = 0;
    setTimeout(() => {
      this.resetShipping();
      this.cdr.detectChanges();
    }, 100);
    this.onCloseModal(modal, layer);
  }

  onChangeCountry(value) {
    if (value != "") {
      this.Common.getPlaces(value, this.city_id).subscribe((data) => {
        if (data.data) {
          this.cities = data.data;
          this.citiesModal = data.data;
        } else {
          //console.log"no data in countries");
        }
      });

      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].id == value) {
          this.country_name = this.countries[i].pla_name;
          this.delivery_price = this.countries[i].delivery_price;
        }
      }
    }
  }

  onChangeCity(value) {
    if (value != "") {
      for (let i = 0; i < this.cities.length; i++) {
        if (this.cities[i].id == value) {
          this.city_name = this.cities[i].pla_name;
          this.delivery_price = this.cities[i].delivery_price;
        }
      }
    }
  }

  async addPaymentInvoice(
    btnInvoice: ElementRef,
    disableLayer: ElementRef,
    invoiceId: string = ""
  ) {
    this.cart_products = JSON.parse(localStorage.getItem("cart_products"));
    let i = parseFloat(localStorage.getItem("storeIndex"));
    console.log(this.cart_products);
    
    if (this.cart_products.selectedAddresse == "") {
      this.myAddresessError = true;
      Swal.fire({
        title: `<h2 class="text-center">${
          this.contactInfoData.tag_title
        }<h2>`,
        text:
          localStorage.getItem("front-lang") == "ar"
            ? "قم باضافة عنوان"
            : "add new address",
        icon: "error",
      });
      return;
    }
    if (
      !this.cart_products.selectedAddresse.user_name ||
      !this.cart_products.selectedAddresse.last_name ||
      !this.cart_products.selectedAddresse.mobile ||
      !this.cart_products.selectedAddresse.district_name
    ) {
      window.scrollTo(0, 0);
      return;
    }
    this.cart_products.panelOpenState = false
    // this.myAddresessError.forEach((ele) => (ele = false));
    this.myAddresessError = false;
    this.quantatyMorThanStor = false;

    window.scrollTo(0, 0);
    const cart = this.cart_products;

    if (this.userLogedIn == true) {
      if (this.products.length > 0) {
        this.product_items = [];

        cart.product_items.forEach((product) => {
          let obj = {
            product_id: product.product_id,
            quantity: product.quantity,
            product_type_name: product.product_type_name,
            offer_id: product.offer_id,
            coupon_value: product.coupon_value,
            is_gift: product.is_gift,
            api_product_id: product.api_product_id,
          };

          if (product.quantity > product["store_amounts_product"]) {
            this.quantatyMorThanStor = true;
            return;
          }
          this.product_items.push(obj);
        });
      }

      let body = {
        payment_method_type: cart.paymentKey,
        payment_method_name: cart.paymentName,
        payment_method_price: cart.paymentPrice,
        cart_id: cart.id,
        transaction_id: invoiceId ? parseFloat(invoiceId) : 0,
        invoice_edit_id: cart["invoice_edit_id"],
        api_invoice_edit_id: cart["api_invoice_edit_id"],
        address_full_name:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse["user_name"] &&
              this.cart_products.selectedAddresse["last_name"]
              ? this.cart_products.selectedAddresse["user_name"] +
                " " +
                this.cart_products.selectedAddresse["last_name"]
              : ""
            : "",
        mobile:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse["mobile"]
              ? this.cart_products.selectedAddresse["mobile"]
              : ""
            : "",
        mobile_2:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse["mobile_2"]
              ? this.cart_products.selectedAddresse["mobile_2"]
              : ""
            : "",
        country_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.country_id)
            : 0,
        city_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.city_id)
            : 0,
        city_name:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse.city_name
            : "",
        district_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.district_id)
            : 0,
        district_name:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse.district_name
            : "",
        address:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse.title
            : "",
        note: cart.note,
        discount:
          parseFloat(cart["total_discount"]),
        coupon_discount: cart.total_coupon_discount,
        marketing_data: cart.marketing_data,
        delivery_price:
          cart.shippingnNum == "my_address" ? parseFloat(cart.deliveryPrice) : 0,
        invoice_items: this.product_items,
        address_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.id)
            : 0,
        shipping_type: cart.shippingnNum,
        total_price_collected_from_customer:
          cart.shippingnNum == "my_address"
            ? cart.total_price_collected_from_customer
            : 0,
        drop_shipping_commission:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.drop_shipping_commission)
            : 0,
        drop_shipping_commission_value:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.drop_shipping_commission_value)
            : 0,
        profit: 0,
        shipment_value:
          cart.shippingnNum == "my_address" ? parseFloat(cart.shippingValue) : 0,
        shipment_company:
          cart.shippingnNum == "my_address" ? cart.shippingCompany : "",
        shipment_id:
          cart.shippingnNum == "my_address" ? parseFloat(cart.shippingId) : 0,
        use_credit: cart.use_credit,
        shipping_method:
          "",
        account_id:
          '',
        status: "pending",
        price_after_discount: (
          cart["total_price"] -
          cart["total_discount"] -
          cart["total_coupon_discount"] -
          cart["total_quantity_discount"] 
          // parseFloat(cart.paymentPrice)
        ).toString(),
        total_quantity_discount: cart["total_quantity_discount"],
        "use_promo": (this.addWallet && !this.isClient && this.promoType == 3) ?  this.promoDiscount : 0,
        "promo_id":(this.addWallet && !this.isClient && this.promoType == 3) ?  3 : 0,
      };

      console.log("cart_products", this.cart_products);
      console.log("body", body);

      this.checkBtnLoader = true;
      const data = await this.orderService
        .addInvoice(body)
        .toPromise();
      if (data.success) {
        console.log("invoiceRestrictions");
        const res = await this.orderService
          .invoiceRestrictions(data.invoice_id)
          .toPromise();
        this.checkLoading = false;
        // this.checkCompleted.splice(i, 1);
        console.log("checkCompleted", this.checkCompleted);
        this.count_invoice = res.count_invoice_type;
        this.emptyCart("", data.invoice_id, cart.id, "request_is_done");
        this.cart_products.splice(i, 1);
        localStorage.setItem(
          "cart_products",
          JSON.stringify(this.cart_products)
        );

        if (this.cart_products.length == 0) {
          this.checkBtnLoader = false;
          this.router.navigate(["/shop/checkout/success"]);
          Swal.fire({
            text: data.message,
          });
        } else {
          this.checkBtnLoader = false;
          Swal.fire({
            text: data.message,
          });
          this.router.navigate(["/shop/checkout"]);
        }
      }
    }
  }
  async addInvoice(btnInvoice: ElementRef, disableLayer: ElementRef) {
    let inventoryStatus = false;
    for (const product of this.cart_products['product_items']) {
      if (product.active == 2 && product['invoice_edit_id'] == '0') {
        Swal.fire({
          html: `
            <span style="color: #dd0e1c;">
            ${product['product_name']}</span>
            جاري جرده لذلك قم بحذفه لاستكمال الطلب!
            `,
          icon: "warning",
          confirmButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default"),
          cancelButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default2"),
        });
        inventoryStatus = true;
        break;
      }
      else if(product.active == 0 && product['invoice_edit_id'] == '0')
      {
        Swal.fire({
          html: `
            <span style="color: #dd0e1c;">
            ${product['product_name']}</span>
            هذا المنتج معطل الآن
            `,
          icon: "warning",
          confirmButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default"),
          cancelButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default2"),
        });

        inventoryStatus = true;
        break;
      }
    }
    if (inventoryStatus == true) {
      return;
    }
      if (this.cart_products.selectedAddresse == "") {
        this.myAddresessError = true;
        Swal.fire({
          title: `<h2 class="text-center">${
          this.contactInfoData?.tag_title
          }<h2>`,
          text:
            localStorage.getItem("front-lang") == "ar"
              ? "قم باضافة عنوان"
              : "add new address",
          icon: "error",
        });
        return;
      }
      if (
        !this.cart_products.selectedAddresse.user_name ||
        !this.cart_products.selectedAddresse.last_name ||
        !this.cart_products.selectedAddresse.mobile ||
        !this.cart_products.selectedAddresse.district_name
      ) {
        window.scrollTo(0, 0);
        return;
      }
    
    // if (!this.paymentName) {
    // console.log("paymentName", this.paymentName);

    //   Swal.fire({
    //     text:
    //       localStorage.getItem("front-lang") == "ar"
    //         ? "قم باختيار طريقة الدفع"
    //         : "must choose payment method",
    //     icon: "error",
    //   });
    //   return;
    // }

    this.renderer.setAttribute(btnInvoice, "disable", "true");
    this.renderer.removeClass(disableLayer, "d-none");

    // this.myAddresessError.forEach((ele) => (ele = false));
    this.myAddresessError=false
    this.quantatyMorThanStor = false;

    window.scrollTo(0, 0);

    let done = 0;
    this.cart_products.panelOpenState = false
    const cart = this.cart_products;

    if (this.userLogedIn == true) {
      if (this.products.length > 0) {
        this.product_items = [];

        cart.product_items.forEach((product) => {
          let obj = {
            product_id: product.product_id,
            quantity: product.quantity,
            product_type_name: product.product_type_name,
            offer_id: product.offer_id,
            coupon_value: product.coupon_value,
            is_gift: product.is_gift,
            api_product_id: product.api_product_id,
          };

          if (product.quantity > product["store_amounts_product"]) {
            this.quantatyMorThanStor = true;
            return;
          }
          this.product_items.push(obj);
        });
      }

      let body = {
        payment_method_type: cart.paymentKey,
        payment_method_name: cart.paymentName,
        payment_method_price: cart.paymentPrice,
        cart_id: cart.id,
        transaction_id: "",
        invoice_edit_id: cart["invoice_edit_id"],
        api_invoice_edit_id: cart["api_invoice_edit_id"],
        address_full_name:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse["user_name"] &&
              this.cart_products.selectedAddresse["last_name"]
              ? this.cart_products.selectedAddresse["user_name"] +
                " " +
                this.cart_products.selectedAddresse["last_name"]
              : ""
            : "",
        mobile:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse["mobile"]
              ? this.cart_products.selectedAddresse["mobile"]
              : ""
            : "",
        mobile_2:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse["mobile_2"]
              ? this.cart_products.selectedAddresse["mobile_2"]
              : ""
            : "",
        country_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.country_id)
            : 0,
        city_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.city_id)
            : 0,
        city_name:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse.city_name
            : "",
        district_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.district_id)
            : 0,
        district_name:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse.district_name
            : "",

        address:
          cart.shippingnNum == "my_address"
            ? this.cart_products.selectedAddresse.title
            : "",
        note: cart.note,
        discount:
          parseFloat(cart["total_discount"]),
        coupon_discount: cart.total_coupon_discount,
        marketing_data: cart.marketing_data,
        delivery_price:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.deliveryPrice)
            : 0,
        invoice_items: this.product_items,
        address_id:
          cart.shippingnNum == "my_address"
            ? parseFloat(this.cart_products.selectedAddresse.id)
            : 0,
        shipping_type: cart.shippingnNum,
        total_price_collected_from_customer:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.total_price_collected_from_customer)
            : 0,
        drop_shipping_commission:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.drop_shipping_commission)
            : 0,
        drop_shipping_commission_value:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.drop_shipping_commission_value)
            : 0,
        profit: 0,
        shipment_value:
          cart.shippingnNum == "my_address"
            ? parseFloat(cart.shippingValue)
            : 0,
        shipment_company:
          cart.shippingnNum == "my_address" ? cart.shippingCompany : "",
        shipment_id:
          cart.shippingnNum == "my_address" ? parseFloat(cart.shippingId) : 0,
        use_credit: cart.use_credit,
        shipping_method:
          "",
        account_id:
          '',
        status: "pending",
        price_after_discount: (
          cart["total_price"] -
          cart["total_discount"] -
          cart["total_coupon_discount"] -
          cart["total_quantity_discount"] 
          // parseFloat(cart.paymentPrice)
        ).toString(),
        total_quantity_discount: cart["total_quantity_discount"],
        "use_promo": (this.addWallet && !this.isClient && this.promoType == 3) ?  this.promoDiscount : 0,
        "promo_id":(this.addWallet && !this.isClient && this.promoType == 3) ?  3 : 0,

      };

      console.log("body", body);

      this.checkLoading = true;
      this.checkBtnLoader = true;
      const data = await this.orderService
        .addInvoice(
          body
        )
        .toPromise();
      if (data.success) {
        console.log("invoiceRestrictions");

        const res = await this.orderService
          .invoiceRestrictions(data.invoice_id)
          .toPromise();
        this.checkLoading = false;
        this.checkCompleted = true;
        console.log(res , 'Invoice successfully')
        this.count_invoice = res.count_invoice_type;
        if (cart["invoice_edit_id"] != "0") {
          this.route.queryParams.subscribe((params) => {
            const paymentId = params["paymentId"];
            if (!paymentId) {
              this.renderer.setAttribute(btnInvoice, "disable", "false");
              this.renderer.addClass(disableLayer, "d-none");
            }
          });

          console.log("invoice EDITED");
          this.emptyCart(
            cart["invoice_edit_id"],
            "",
            cart.id,
            "request_is_done"
          );
          Swal.fire({
            text: data.message,
          });
          this.checkBtnLoader = false;
          this.router.navigate([""]);
        } else {
          this.emptyCart("", data.invoice_id, cart.id, "request_is_done");
          this.checkBtnLoader = false;
          this.router.navigate(["/shop/checkout/success"]);
          this.route.queryParams.subscribe((params) => {
            const paymentId = params["paymentId"];
            if (!paymentId) {
              this.renderer.setAttribute(btnInvoice, "disable", "false");
              this.renderer.addClass(disableLayer, "d-none");
            }
          });

          Swal.fire({
            text: data.message,
          });
          
        }
      } else {
        this.checkLoading = false;
        this.checkCompleted = true;
        if (
          data.message ==
          "TheOrderHasBeenExecutedDoYouWantToAddANewOrderOrCancel"
        ) {
          this.addInvoiceErrorResponce =
            this.Common._lang_code == "ar"
              ? "لقد تم تنفيذ الطلب. هل تريد إضافة طلب جديد أم إلفاء تعديل الطلب؟"
              : "The Order Has Been Executed Do You Want To Add A New Order Or Cancel?";
          Swal.fire({
            text: (this.addInvoiceErrorResponce =
              this.addInvoiceErrorResponce),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: getComputedStyle(
              document.querySelector("app-root")
            ).getPropertyValue("--theme-default"),
            cancelButtonColor: getComputedStyle(
              document.querySelector("app-root")
            ).getPropertyValue("--theme-default2"),
            // cancelButtonColor: "var(--theme-default)",
            confirmButtonText: "أضف طلب جديد",
            cancelButtonText: "إلغاء التعديل",
          }).then((result) => {
            if (result.isConfirmed) {
              console.log("cart", cart);
              let body = {
                payment_method_type: cart.paymentKey,
                payment_method_name: cart.paymentName,
                payment_method_price: cart.paymentPrice,
                city_id: cart.selectedAddresse.city_id,
                city_name: cart.selectedAddresse.city_name,
                district_id: cart.selectedAddresse.district_id,
                district_name: cart.selectedAddresse.district_name,
                address: cart.selectedAddresse,
                note: cart.note,
                delivery_price: cart.deliveryPrice,
                invoice_items: this.product_items,
                cart_id: cart.id,
                marketing_data: this.marketingData,
                coupon_discount: this.couponDiscount,
                discount: this.totalDiscounts,
                shipment_id: cart.shippingId,
                shipment_value: cart.shippingValue,
                shipment_company: cart.shippingCompany,
              };
              this.orderService
                .addInvoice(
                  body
                )
                .subscribe((data) => {
                  if (data.success) {
                    this.emptyCart(
                      "",
                      data.invoice_id,
                      cart.id,
                      "request_is_done"
                    );
                    this.resetData();
                    this.router.navigate([
                      "/shop/checkout/success/" + data.invoice_id,
                    ]);
                  } else {
                    this.addInvoiceErrorResponce = data.message;
                    console.log("addInvoice in server again NO");
                    Swal.fire({
                      text: this.addInvoiceErrorResponce,
                    });
                  }
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              this.Common.emptyCart(
                cart["invoice_edit_id"],
                "",
                cart.id,
                "canceled"
              ).subscribe((data) => {
                if (data.success) {
                  Swal.fire({
                    text: data.data,
                  });
                  this.router.navigate(["/"]);
                } else {
                  //console.log"errors  in server", data.errors);
                  return;
                }
              });
            }
          });
          this.addInvoiceErrorResponce = data.message;
          this.checkLoading = false;
          this.checkBtnLoader = false;
          this.checkCompleted = true;
        } else {
          this.route.queryParams.subscribe((params) => {
            const paymentId = params["paymentId"];
            if (!paymentId) {
              this.renderer.setAttribute(btnInvoice, "disable", "false");
              this.renderer.addClass(disableLayer, "d-none");
            }
          });
          this.addInvoiceErrorResponce = data.message;
          this.checkBtnLoader = false;
          console.log("data", data);
          Swal.fire({
            title: `<h2 class="text-center">${this.addInvoiceErrorResponce}<h2>`,
            text: data.errors.invoice_items,
            icon: "error",
          });
          this.router.navigate(["/"]);
          
        }
      }
    }
    
  }

  selectComapny(radioContainer, btnCompany, company) {
    this.onChangeCompany(
      btnCompany.value,
      company,
      radioContainer,
      btnCompany,
      
    );
  }
  onChangeCompany(value,  company, radioContainer, btnCompany) {
    console.log("btnCompany", btnCompany);
    this.radioContainer.forEach((ele) => {
      ele.nativeElement.style.border = `1px solid #dddddd`;
    });
    radioContainer.style.border = `2px solid ${this.myColor}`;
    btnCompany.checked = true;
    this.cart_products.deliveryPrice = parseFloat(company.delivery_price);
    this.cart_products.shippingValue = company.shipment_value;
    this.cart_products.shippingId = company.shipment_id;
    this.cart_products.shippingCompany = company.shipment_company;
  }

  selectPayment(
    paymentContainer,
    btnPayment,
    paymentKey,
    paymentName,
    paymentPrice,
    
  ) {
    if (this.noTotalAmmount && paymentKey !== 'payment_method_home' ) {
      return;
    }
    console.log("paymentKey", paymentKey);
    console.log("promokey", this.noTotalAmmount);
    
    this.onChangePayment(
      paymentKey,
      paymentName,
      paymentPrice,
      paymentContainer,
      btnPayment,
      
    );
  }
  onChangePayment(
    paymentKey,
    paymentName,
    paymentPrice,
    paymentContainer,
    btnPayment,
  ) {
    this.paymentContainer.forEach((ele) => {
      ele.nativeElement.style.border = `1px solid #dddddd`;
    });
    paymentContainer.style.border = `2px solid ${this.myColor}`;
    btnPayment.checked = true;
    this.cart_products.paymentKey = paymentKey;
    this.cart_products.paymentName = paymentName;
    this.cart_products.paymentPrice = paymentPrice;
    this.cart_products.paymentServicePrice = parseFloat(
      this.cart_products.paymentPrice
    );
  }
  generateTrackId(){
    // Generate a random alphanumeric string or a UUID for the track ID
    return 'TRK' + Math.random().toString(36).substr(2, 9).toUpperCase();
  };
  
  onSubmitKnet() {
    const data = {
      terminalId: '',
      terminalPassword: '',
      amount: ((this.cart_products['total_price'] - this.cart_products['total_coupon_discount'] -
        this.cart_products['total_discount'] + this.cart_products.deliveryPrice-
        this.cart_products['total_quantity_discount'] + (+this.cart_products.paymentServicePrice))).toFixed(3),
      trackId:  this.generateTrackId(),
      responseURL: 'http://192.168.1.201:4200/shop/checkout',
      errorURL: 'http://192.168.1.201:4200/shop/checkout',
    };
    this.paymentService.initializePayment(data).subscribe((response) => {
      // Handle KNET response
      window.open(response, '_blank'); // Redirect to KNET payment page
    });
  }
  resetData() {
    this.countries = [];
    this.country_id = "";
    this.country_name = "";
    this.cities = [];
    this.city_id = "";
    this.city_name = "";
    this.district_id = "";
    this.district_name = "";
    this.address = "";
    // this.note = "";
    this.delivery_price = "";
    this.product_items = [];
    localStorage.setItem(
      "cartItems",
      JSON.stringify([])
    ); /* maybe Error Here */
    // reset basket
  }

  emptyCart(invoiceEditId: any, invoiceId: any, cartId: any, type: any) {
    this.Common.emptyCart(invoiceEditId, invoiceId, cartId, type).subscribe(
      (data) => {
        // console.log(data);
        if (data.data) {
          //this.Common.changeCart("");
          this.Common.UpdatedSetting.next("checked");
          this.Common.Updatedheaderone.next("checked");
          //console.log"emptyCart in server");
        } else {
          //console.log"errors  in server", data.errors);
          return;
        }
      }
    );
  }

  public get getTotal(): Observable<number> {
    return this.productService.cartTotalAmount();
  }
  handleImageError(e) {
    e.src = "assets/images/product/placeholder2.jpg";
  }
  // Stripe Payment Gateway
  stripeCheckout() {
    var handler = (<any>window).StripeCheckout.configure({
      key: environment.stripe_token, // publishble key
      locale: "auto",
      token: (token: any) => {
        // You can access the token ID with `token.id`.
        // Get the token ID to your server-side code for use.
        this.orderService.createOrder(
          this.products,
          this.checkoutForm.value,
          token.id,
          this.amount
        );
      },
    });
    handler.open({
      name: "Multikart",
      description: "Online Fashion Store",
      amount: this.amount * 100,
    });
  }

  // Paypal Payment Gateway
  private initConfig(): void {
    this.payPalConfig = {
      currency: this.productService.Currency?.currency,
      clientId: environment.paypal_token,
      createOrderOnClient: (data) =>
        <ICreateOrderRequest>{
          intent: "CAPTURE",
          purchase_units: [
            {
              amount: {
                currency_code: this.productService.Currency.currency,
                value: this.amount,
                breakdown: {
                  item_total: {
                    currency_code: this.productService.Currency.currency,
                    value: this.amount,
                  },
                },
              },
            },
          ],
        },
      advanced: {
        commit: "true",
      },
      style: {
        label: "paypal",
        size: "small", // small | medium | large | responsive
        shape: "rect", // pill | rect
      },
      onApprove: (data, actions) => {
        this.orderService.createOrder(
          this.products,
          this.checkoutForm.value,
          data.orderID,
          this.getTotal
        );
        // console.log(
        //   "onApprove - transaction was approved, but not authorized",
        //   data,
        //   actions
        // );
        actions.order.get().then((details) => {
          // console.log(
          //   "onApprove - you can get full order details inside onApprove: ",
          //   details
          // );
        });
      },
      onClientAuthorization: (data) => {
        // console.log(
        //   "onClientAuthorization - you should probably inform your server about completed transaction at this point",
        //   data
        // );
      },
      onCancel: (data, actions) => {
        // console.log("OnCancel", data, actions);
      },
      onError: (err) => {
        // console.log("OnError", err);
      },
      onClick: (data, actions) => {
        // console.log("onClick", data, actions);
      },
    };
  }

  homeExpandeed: boolean = true;
  storeExpanded: boolean = false;
  homeChecked(i) {
    console.log('hgjoksla;a;ldkfjgh');
    
    this.cart_products.shippingMethodBlock = true;
    let homeInput = this.home?.filter(
      (ele) => ele?.nativeElement.getAttribute("data-custom-index") == i
    )[0];
    let storeInput = this.store?.filter(
      (ele) => ele?.nativeElement.getAttribute("data-custom-index") == i
    )[0];
    this.cart_products.shippingnNum = "my_address";
    if (storeInput) {
      storeInput.nativeElement.checked = false;
    }
    if (homeInput) {
      homeInput.nativeElement.checked = true;
    }
    this.homeExpandeed = true;
    this.storeExpanded = false;
    setTimeout(() => {
      this.resetShipping();
    }, 100);

  }
  storeChecked(i) {
    this.cart_products.shippingMethodBlock = false;
    let homeInput = this.home.filter(
      (ele) => ele.nativeElement.getAttribute("data-custom-index") == i
    )[0];
    let storeInput = this.store.filter(
      (ele) => ele.nativeElement.getAttribute("data-custom-index") == i
    )[0];
    this.cart_products.shippingnNum = "shipping_from_store";
    if (storeInput) {
      storeInput.nativeElement.checked = true;
    }
    if (homeInput) {
      homeInput.nativeElement.checked = false;
    }
    this.homeExpandeed = false;
    this.storeExpanded = true;
    let cartitem = this.cart_products
    cartitem.deliveryPrice = 0;
    console.log(this.cart_products);
    this.getPromoDiscountValue();
  }
  preventToggle(e: MouseEvent) {
    e.preventDefault();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async openModal(index: number, status: string) {
    this.resetForm();
    this.successUser_name = false;
    this.successLast_name = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;
    this.mobileIsInValid = false;
    this.mobileIsValid = false;
    this.successMobile2 = false;
    this.mobile2IsInValid = false;
    this.mobile2IsValid = false;
    this.step22 = false;
    this.step33 = false;
    this.step11 = false;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;

    this.addStep = false;
    this.editStep = false;
    if (status == "add") {
      this.step1 = true;
      this.step4 = false;
    }
    this.is_default = "1";
    if (status == "edit") {
      this.city_idModal = this.myAddresess[index].city_id;
      await this.onCityChange(this.city_idModal);
      this.step1 = false;
      this.step4 = true;
      // console.log("address", this.myAddresess[index]);

      this.district_id =
        this.myAddresess[index].district_id == "0"
          ? ""
          : this.myAddresess[index].district_id;
      this.district_name = this.myAddresess[index].district_name || "";
      this.city_name = this.myAddresess[index].city_name;
      this.address_id = this.myAddresess[index].id;
      this.title = this.myAddresess[index].title;
      this.user_name = this.myAddresess[index].user_name;
      this.last_name = this.myAddresess[index].last_name;
      this.mobile_data = this.myAddresess[index].mobile;
      this.mobile2_data = this.myAddresess[index].mobile_2;
      this.is_default = this.myAddresess[index].is_default;
      console.log("dist", this.district_id);

      if (this.mobile2_data) {
        this.valid2_mobile = this.formatMobileNumber(this.mobile2_data);
      } else {
        this.valid2_mobile = "";
      }
      if (this.mobile_data) {
        this.valid_mobile = this.formatMobileNumber(this.mobile_data);
      } else {
        this.valid_mobile = "";
      }
    } else {
      this.title = "";
      this.city_idModal = "";
      this.district_id = "";
      this.city_name = "";
      this.district_name = "";
      this.user_name = this.currentUser.user_name;
      this.last_name = this.currentUser.last_name || "";
      this.mobile_data = this.currentUser.mobile;
      this.mobile2_data = "";
      if (this.mobile_data) {
        this.valid_mobile = this.formatMobileNumber(this.mobile_data);
      } else {
        this.valid_mobile = "";
      }
    }
    console.log('cc');
    
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.modalService
        .open(this.NewsLetterModal, {
          size: "md",
          ariaLabelledBy: "NewsLetter-Modal",
          centered: true,
          windowClass: "theme-modal newsletterm NewsLetterModal",
        })
        .result.then(
          (result) => {
            this.modalOpen = true;
            `Result ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }
  resetForm() {
    this.checkoutForm.controls["title"].reset();
    this.checkoutForm.controls["title"].setErrors(null);
    this.checkoutForm.controls["title"].markAsUntouched();
    this.checkoutForm.controls["city"].reset();
    this.checkoutForm.controls["city"].setErrors(null);
    this.checkoutForm.controls["city"].markAsUntouched();
    this.checkoutForm.controls["District"].reset();
    this.checkoutForm.controls["District"].setErrors(null);
    this.checkoutForm.controls["District"].markAsUntouched();
  }


  toggleWallet()
  {
    this.noTotalAmmount = !this.noTotalAmmount
    this.addWallet = !this.addWallet
    console.log(this.paymentContainer.first.nativeElement , this.btnPayments.first._elementRef.nativeElement);
    
    if (this.noTotalAmmount) {
      this.selectPayment(this.paymentContainer.first.nativeElement , this.btnPayments.first._elementRef.nativeElement , this.paymentInfo[0].key , this.paymentInfo[0].name , this.paymentInfo[0].price)
    }
    this.btnPayments.first.checked = true
    console.log(this.noTotalAmmount);
    console.log(this.btnPayments.first.checked);
    
  }
  openPaymentModal(index) {
    let inventoryStatus = false;
    for (const product of this.cart_products['product_items']) {
      if (product.active == 2 && product['invoice_edit_id'] == '0') {
        Swal.fire({
          html: `
            <span style="color: #dd0e1c;">
            ${product['product_name']}</span>
            ${this.translateService.instant('It is inventoried so delete it to complete the order!')}
            `,
          icon: "warning",
          confirmButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default"),
          cancelButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default2"),
        });
        inventoryStatus = true;
        break;
      }
      else if(product.active == 0 && product['invoice_edit_id'] == '0')
      {
        Swal.fire({
          html: `
            <span style="color: #dd0e1c;">
            ${product['product_name']}</span>
            هذا المنتج معطل الآن
            `,
          icon: "warning",
          confirmButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default"),
          cancelButtonColor: getComputedStyle(
            document.querySelector("app-root")
          ).getPropertyValue("--theme-default2"),
        });

        inventoryStatus = true;
        break;
      }
    }
    if (inventoryStatus == true) {
      this.resetPayment(index);
      return;
    };
    this.index = index;
    localStorage.setItem("storeIndex", index);
    // if (
    //   !this.cart_products.selectedAddresse.user_name ||
    //   !this.cart_products.selectedAddresse.last_name ||
    //   !this.cart_products.selectedAddresse.mobile
    // ) {
    //   setTimeout(() => {
    //     this.resetPayment(index);
    //     this.cdr.detectChanges();
    //   }, 100);
    //   window.scrollTo(0, 0);
    //   return;
    // }

    if (
      !this.cart_products.selectedAddresse.user_name ||
      !this.cart_products.selectedAddresse.last_name ||
      !this.cart_products.selectedAddresse.mobile
    ) {
      this.myAddresessError = true;
      Swal.fire({
        title: `<h2 class="text-center">${
          " المخزن الرئيسي "
        }<h2>`,
        text:
          localStorage.getItem("front-lang") == "ar"
            ? "قم باضافة عنوان"
            : "add new address",
        icon: "error",
      });
      setTimeout(() => {
        this.resetPayment(index);
        this.cdr.detectChanges();
      }, 100);
      return;
    }
    localStorage.setItem("cart_products", JSON.stringify(this.cart_products));
    this.getPaymentMethodsAfterCalculation();
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.modalService
        .open(this.paymentModal, {
          size: "md",
          ariaLabelledBy: "payment-Modal",
          centered: true,
          windowClass: "theme-modal newsletterm paymentModal",
        })
        .result.then(
          (result) => {
            this.modalOpen = true;
            `Result ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }
  resetPayment(cartIndex: number) {
    const paymentContainersArray = this.paymentContainer.toArray();
    const btnPaymentsArray = this.btnPayments.toArray();

    const cartItem = this.cart_products;
    const startPaymentIndex = cartIndex * this.paymentInfo.length;
    const endPaymentIndex = startPaymentIndex + this.paymentInfo.length;

    const cartItemPaymentContainers = paymentContainersArray.slice(
      startPaymentIndex,
      endPaymentIndex
    );

    const cartItemBtnPayments = btnPaymentsArray.slice(
      startPaymentIndex,
      endPaymentIndex
    );

    if (
      cartItemPaymentContainers.length > 0 &&
      cartItemBtnPayments.length > 0
    ) {
      cartItemPaymentContainers.forEach((paymentContainer) => {
        paymentContainer.nativeElement.style.border = `1px solid #dddddd`;
      });

      cartItemBtnPayments.forEach((btnPayment) => {
        btnPayment.checked = false;
      });

      cartItemPaymentContainers[0].nativeElement.style.border = `2px solid ${this.myColor}`;
      cartItemBtnPayments[0].checked = true;
      cartItem.paymentKey = "payment_method_home";
      cartItem.paymentName = this.contactInfoData.payment_method_home_name;
      cartItem.paymentPrice = this.contactInfoData.payment_method_home_price;
      cartItem.paymentServicePrice = parseFloat(cartItem.paymentPrice);
      console.log(cartItemBtnPayments[0]);
    }
  }
  resetShipping() {
    const shippingContainersArray = this.radioContainer.toArray();
    const btnCompaniesArray = this.btnCompanies.toArray();
    let totalShippingMethodsLength = 0;

    let cartItem = this.cart_products;
    if (
      cartItem.selectedAddresse &&
      cartItem.selectedAddresse.shipping_methods
    ) {
      totalShippingMethodsLength +=
        cartItem.selectedAddresse.shipping_methods.length;
    }
  

    const startShippingIndex = totalShippingMethodsLength;
    let cartitem = this.cart_products;
    const endShippingIndex =
      startShippingIndex +
      (cartitem?.selectedAddresse?.shipping_methods?.length || 0);

    const cartItemCompanyContainers = shippingContainersArray.slice(
      startShippingIndex,
      endShippingIndex
    );
    const cartItemBtnCompanies = btnCompaniesArray.slice(
      startShippingIndex,
      endShippingIndex
    );

    console.log(this.cart_products, cartitem.shippingIndex);

    if (
      cartItemCompanyContainers.length > 0 &&
      cartItemBtnCompanies.length > 0
    ) {
      // Reset all to false first
      cartItemBtnCompanies.forEach(
        (btnCompany) => (btnCompany.checked = false)
      );

      cartItemCompanyContainers.forEach(
        (cartItemCompanyContainer) =>
          (cartItemCompanyContainer.nativeElement.style.border = `1px solid #dddddd`)
      );

      cartItemCompanyContainers[
        cartitem.shippingIndex
      ].nativeElement.style.border = `2px solid ${this.myColor}`;
      cartItemBtnCompanies[cartitem.shippingIndex].checked = true;

      let company =
        cartitem.selectedAddresse?.shipping_methods[cartitem.shippingIndex];

      cartitem.deliveryPrice = parseFloat(company.delivery_price);
      cartitem.shippingValue = company.shipment_value;
      cartitem.shippingId = company.shipment_id;
      cartitem.shippingCompany = company.shipment_company;
      cartitem.shippingIndex = cartitem.shippingIndex
        ? cartitem.shippingIndex
        : 0;
      
      }
      this.getPromoDiscountValue();
  }

  opendeleteModal(address_id) {
    this.step2 = false;
    this.step3 = false;
    this.step1 = false;
    this.step22 = false;
    this.step33 = false;
    this.step11 = true;

    if (address_id != "" && address_id > 0) {
      this.delete_address_id = address_id;
      if (isPlatformBrowser(this.platformId)) {
        // For SSR
        this.modalService
          .open(this.NewsLetterModal, {
            size: "md",
            ariaLabelledBy: "NewsLetter-Modal",
            centered: true,
            windowClass: "theme-modal newsletterm NewsLetterModal",
          })
          .result.then(
            (result) => {
              this.modalOpen = true;
              `Result ${result}`;
            },
            (reason) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
          );
      }
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  addAddress() {
    this.successUser_name = false;
    this.successLast_name = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;
    this.mobileIsInValid = false;
    this.mobileIsValid = false;
    this.successMobile2 = false;
    this.mobile2IsInValid = false;
    this.mobile2IsValid = false;

    if (this.user_name == "" || this.user_name.length < 3) {
      this.successUser_name = true;
      this.translateService
        .get("first name message")
        .subscribe((translatedMessage: any) => {
          this.errorUserNameMessage = translatedMessage;
        });
      return;
    }
    if (this.last_name == "" || this.last_name.length < 3) {
      this.successLast_name = true;
      this.translateService
        .get("last name message")
        .subscribe((translatedMessage: any) => {
          this.errorLastNameMessage = translatedMessage;
        });
      return;
    }

    if (!this.startsWithAny(this.mobile_keys, this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length < this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("short mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length > this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("long mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (!this.mobilePattern.test(this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("valid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    }
    if (!this.successMobile) {
      this.mobileIsValid = true;
      this.mobileIsInValid = false;
    }
    if (this.mobile2_data != "") {
      if (!this.startsWithAny(this.mobile_keys, this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("invalid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length < this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("short mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length > this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("long mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (!this.mobilePattern.test(this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("valid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      }
      if (!this.successMobile2) {
        this.mobile2IsValid = true;
        this.mobile2IsInValid = false;
      }
    }
    if (
      this.title == "" ||
      this.city_idModal == "" ||
      this.country_idModal == "" ||
      this.district_id == ""
    ) {
      this.checkoutForm.markAllAsTouched();
      return;
    }
    this.step2 = true;
    this.addStep = true;

    this.step3 = false;
    this.step1 = false;
    this.step4 = false;
    if (this.userLogedIn == true) {
      let body = {
        title: this.title,
        city_id: this.city_idModal,
        district_id: this.district_id,
        city_name: this.city_name,
        district_name: this.district_name,
        country_id: this.country_idModal,
        is_default: this.is_default,
        user_name: this.user_name,
        last_name: this.last_name,
        mobile: this.valid_mobile,
        mobile_2: this.valid2_mobile,
      };
      this.user.addAddress(body).subscribe((data) => {
        if (data.success) {
          this.step1 = false;
          this.step4 = false;
          this.step2 = false;
          this.step3 = true;
          this.addStep = true;
          this.getAllAddress();
        } else {
          return;
        }
      });
    } else {
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }

  editAddress() {
    this.successUser_name = false;
    this.successLast_name = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;
    this.mobileIsInValid = false;
    this.mobileIsValid = false;
    this.successMobile2 = false;
    this.mobile2IsInValid = false;
    this.mobile2IsValid = false;

    if (!this.user_name || this.user_name.length < 3) {
      this.successUser_name = true;
      this.translateService
        .get("first name message")
        .subscribe((translatedMessage: any) => {
          this.errorUserNameMessage = translatedMessage;
        });
      return;
    }
    if (!this.last_name || this.last_name.length < 3) {
      this.successLast_name = true;
      this.translateService
        .get("last name message")
        .subscribe((translatedMessage: any) => {
          this.errorLastNameMessage = translatedMessage;
        });
      return;
    }

    if (!this.startsWithAny(this.mobile_keys, this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("invalid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length < this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("short mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (this.valid_mobile.length > this.mobileLength) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("long mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    } else if (!this.mobilePattern.test(this.valid_mobile)) {
      this.successMobile = true;
      this.mobileIsInValid = true;
      this.translateService
        .get("valid mobile message")
        .subscribe((translatedMessage: any) => {
          this.errorMobileMessage = translatedMessage;
        });
      return;
    }
    if (!this.successMobile) {
      this.mobileIsValid = true;
      this.mobileIsInValid = false;
    }

    if (this.mobile2_data != null && this.mobile2_data != "") {
      if (!this.startsWithAny(this.mobile_keys, this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("invalid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length < this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("short mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (this.valid2_mobile.length > this.mobileLength) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("long mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      } else if (!this.mobilePattern.test(this.valid2_mobile)) {
        this.successMobile2 = true;
        this.mobile2IsInValid = true;
        this.translateService
          .get("valid mobile message")
          .subscribe((translatedMessage: any) => {
            this.errorMobileMessage2 = translatedMessage;
          });
        return;
      }
      if (!this.successMobile2) {
        this.mobile2IsValid = true;
        this.mobile2IsInValid = false;
      }
    }

    if (
      this.title == "" ||
      this.city_idModal == "" ||
      this.country_idModal == "" ||
      this.district_id == "" ||
      this.district_id == "0"
    ) {
      this.checkoutForm.markAllAsTouched();
      return;
    }
    this.step2 = true;
    this.editStep = true;
    this.step3 = false;
    this.step1 = false;
    this.step4 = false;
    if (this.userLogedIn == true) {
      let body = {
        id: this.address_id,
        title: this.title,
        city_id: this.city_idModal,
        district_id: this.district_id,
        city_name: this.city_name,
        district_name: this.district_name,
        country_id: this.country_idModal,
        is_default: this.is_default,
        user_name: this.user_name,
        last_name: this.last_name,
        mobile: this.valid_mobile,
        mobile_2: this.valid2_mobile,
      };
      this.user.editAddress(body).subscribe((data) => {
        this.getAllAddress();
        if (data.success) {
          this.step1 = false;
          this.step4 = false;
          this.step2 = false;
          this.step3 = true;
          this.editStep = true;
          // this.getAllAddress();
        } else {
          return;
        }
      });
    } else {
      this.goToLogin();
    }
  }

  deleteAddress(id) {
    if (this.delete_address_id != "") {
      this.step11 = false;
      this.step22 = true;
      this.step33 = false;

      if (this.userLogedIn == true) {
        let body = {
          address_id: id,
        };
        this.user.deleteAddress(body).subscribe((data) => {
          if (data.success) {
            this.step11 = false;
            this.step22 = false;
            this.step33 = true;
            this.getAllAddress();
          } else {
            this.step11 = false;
            this.step22 = false;
            this.step33 = false;
            return;
          }
        });
      } else {
        // this.router.navigate(["/pages/login"]);
        this.goToLogin();
      }
    }
  }

  loginclicked: boolean = false;

  goToLogin() {
    this.loginclicked = true;
  }
  close() {
    this.loginclicked = false;
  }

  calculateTextColor(): string {
    return this.Common.tinyColor("var(--theme-default)");
  }
  paymentMethods: any[] = [];
  selectedPaymentMethod: string = "";

  getPaymentMethods(totalPrice: any): void {
    const body = {
      InvoiceAmount: totalPrice,
      CurrencyIso: this.contactInfoData.payment_gateway_currency_iso,
    };

    this.FatoorahPaymentService.getPaymentMethods(
      body,
      this.contactInfoData.payment_gateway_api_key
    ).subscribe(
      (response) => {
        if (response.IsSuccess) {
          this.paymentMethods = response.Data.PaymentMethods;
          this.paymentLoading = false;
        } else {
          // Handle error
          console.error("Failed to fetch payment methods", response);
        }
      },
      (error) => {
        console.error("API error", error);
      }
    );
  }

  ExecutePayment(method: any): void {
    this.user_info = JSON.parse(localStorage.getItem("currentUserFront"));
    const paymentData = {
      InvoiceValue: method.TotalAmount,
      Language: this.Common.isRtl ? "ar" : "en",
      PaymentMethodId: method.PaymentMethodId,
      DisplayCurrencyIso: this.contactInfoData.payment_gateway_currency_iso,
      CustomerName: `${this.user_info.user_name} ${this.user_info.last_name}`,
      MobileCountryCode: this.country_code,
      UserDefinedField: "CK-" + this.user_info.id,
      CustomerMobile: this.user_info.mobile,
      CustomerEmail: this.user_info.email,
      CustomerCivilId: this.user_info.id,
      CustomerReference: this.cart_products.id,
      CallBackUrl: this.baseUrl + "/shop/checkout",
    };
    this.FatoorahPaymentService.ExecutePayment(
      paymentData,
      this.contactInfoData.payment_gateway_api_key
    ).subscribe({
      next: (response) => {
        console.log(response);
        if (response.IsSuccess) {
          window.location.href = response.Data.PaymentURL;
        } else {
          console.error("Payment failed", response);
        }
      },
      error: (err: any) => {
        console.log(err);
        console.log(err?.error);
        if (err?.error.Message == "Invalid data") {
          Swal.fire({
            title: `<h2 class="text-center">${
              localStorage.getItem("front-lang") == "ar" ? 'خطأ في البيانات' :'Invalid Data'
            }<h2>`,
            text:
              localStorage.getItem("front-lang") == "ar"
                ? "تأكد من وجود ايميل او رقم الهاتف"
                : "Check your Email or Phone number",
            icon: "error",
          });
        }
      },
    });
  }

  updateNote(note: string, index: number) {
    this.cart_products.note = note;
  }
}
function viewchild(
  store: any
): (target: CheckoutComponent, propertyKey: "") => void {
  throw new Error("Function not implemented.");
}

